export default __webpack_public_path__ + "static/media/icon-share-blue.1eaa5746.svg";